import React from "react";
//import ReactDOM from 'react-dom';
import axios from 'axios';
import Slider from "react-slick";
import  './Slidearrow.css';
//import Products from './Products';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import  './ProductListSlider.css';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import ProductsHome from "./ProductsHome";

class Newarrivals extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            
            list : [],pass : []

        }
    }; 
    componentDidMount(){
      axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/method/ecom.api.latest_items?pin='+localStorage.getItem('pin')), {
          headers : {
      'content-type': 'application/json'}
      })
      .then(response=>{
          this.setState({list:response.data.message})
          //console.log(response.data.data)  
      })
      .catch(response=>{
          // console.log(response+' api/method/ecom.api.latest_items')
      })
  } 
    render() {
        var settings = {
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
            slidesToShow: 5,
            slidesToScroll: 1,
            pauseOnHover: true,
            nextArrow: (
              <div>
                <div className="next-slick-arrow mob-d-none"> <ArrowForwardIosIcon/> </div>
              </div>
            ),
          prevArrow: (
              <div>
                 <div className="next-slick-arrow mob-d-none"> <ArrowBackIosNewIcon/> </div>
              </div>
            ), 
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    arrows: false,
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                    arrows: false,
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                  }
                }
              ]
        }
              
        if(this.state.list.length > 5)
         return <div className="arrival-area mt-20px mb-15px">
                  <div className="container">
                      <div className="row">
                          <div className="col-md-12">
                              <div className="section-title">
                                  <h2>New Arrivals</h2>
                                  {/* <!-- Nav tabs --> */}
                                  <ul className="nav nav-tabs sub-category">
                                      <li className="nav-item">
                                          <a className="nav-link active view-all-text"  href="/new-arrivals">View All</a>
                                      </li>
                                  </ul>
                                  {/* <!-- Nav tabs --> */}
                              </div>
                          </div>
                      </div>
                        {/* <!-- tab content --> */}
                      <div className="tab-content">
                          {/* <!-- First-Tab --> */}
                          <div id="tab-1" className="tab-pane active fade">
                            {/* <!-- Arrivel slider start --> */}
                            <Slider {...settings}>
                              {this.state.list.map((item,k)=>{
                                      return(



<ProductsHome key={k} data={item}/>



                               )
                              })}           
                    </Slider> 
                              {/*  <!-- Arrivel slider end --> */}
                          </div>
                          {/*  <!-- First-Tab --> */}
                      </div>
                        {/* <!-- tab content end--> */}
                  </div>
              </div>   

         else
          return""
     }
 }
 export default Newarrivals;